/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import APIClient from "../client";
import { Button, Dropdown, Tab, Tabs } from "react-bootstrap";
import Jobs from "./Jobs";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";

class LinkJohnDeere extends React.Component {
  state = {
    showModal: false,
    account: null,
    organization: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateJDState = () => {
      this.loadAccount();
    };
  }
  componentWillUnmount() {
    delete cropr.updateJDState;
  }

  loadAccount = () => {
    fetch("/apps/cloudfarm/get_tractors/J/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), [
              "John Deere",
            ])
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
              organization: account.jd_selected_org,
              showWarning: false,
            });
          });
        } else {
          throw { status: response.status };
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
          organization: null,
        });
      });
  };

  authorizeAccount() {
    fetch("/apps/cloudfarm/jd_authorization_url/")
      .then(function (response) {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw { status: response.status };
        }
      })
      .then((json) => {
        window.open(json.jd_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  }

  async changeOrganization(orgId) {
    const formData = new FormData();
    formData.append("organization_id", orgId);
    try {
      await APIClient.post(
        "/api/data/users/set_jd_org/",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("De organization has been set."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("De organization could not be linked at this time."));
    }
  }

  async removeAccount() {
    try {
      await APIClient.remove(
        "/api/data/users/delete_jd_credentials/",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been deleted successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
  }

  findConnectionLink(org_id){
    if (!this.state.account) {
      return null;
    }
    const organisation = this.state.account.organizations.find((org) => org.id===this.state.organization)
    if (!organisation || !organisation.links){
      return null;
    }
    const connLink = organisation.links.find((link) => link.rel === "connections");
    if (!connLink) {
      return null;
    }
    return connLink.uri;
  }
  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with John Deere")}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              MyJohnDeere Operations Center account{" "}
              <img
                className="float-right"
                src="/static/img/JOHN DEERE.png"
                alt="John Deere"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.organization && this.findConnectionLink(this.state.organization) && (
              <div className="alert alert-error mt-2">
                {gettext("Please allow access to the selected organization")}
                <a className="btn btn-info mr-1 ml-2" target="_blank"
                   href={this.findConnectionLink(this.state.organization)}> {gettext("Allow access")}</a>
                <a className="btn btn-success mr-1" onClick={() => this.loadAccount()}>
                  {gettext("Refresh")}
                </a>
              </div>
            )}
            <Tabs defaultActiveKey={this.state.organization ? "tractors" : "account"}>
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info" id="jd-connect-allow-popups">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}:{this.state.account.jd_username}
                    </h4>
                    <div className="mt-2">
                      <span className="align-middle">{gettext("Organization: ")}</span>
                      <select
                        id="jd-org-select"
                        className="custom-select custom-select-sm ml-2 w-50"
                        style={{ background: "none" }}
                        defaultValue={this.state.organization || ""}
                        onChange={(e) => this.changeOrganization(e.target.value)}
                      >
                        {!this.state.organization ? (
                          <option key="-" value="">
                            {"--" + gettext("Choose") + "--"}
                          </option>
                        ) : null}
                        {this.state.account.organizations.map((org) => (
                          <option value={org.id} key={org.id}>
                            {org.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mt-4">
                      <a className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div id="jd_authorization">
                    <div className="mt-4">
                      <a className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Authorize")}
                      </a>
                    </div>
                  </div>
                )}
              </Tab>
              <Tab
                eventKey="tractors"
                title={gettext("Tractors")}
                disabled={!this.state.organization}
              >
                {this.state.organization ? (
                  <Tractors
                    accountName={this.state.account.jd_username}
                    headers={[gettext("Name"), gettext("Vehicle type"), gettext("Model")]}
                    tractors={this.state.account.tractors.map((t, i) => ({
                      display: [
                        t.name,
                        t.equipmentType ? t.equipmentType.name : "",
                        t.equipmentModel ? t.equipmentModel.name : "",
                      ],
                      serialNr: t.vin,
                      receiveOnly: false,
                    }))}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.organization}>
                {this.state.organization ? <Jobs online_service="J" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">
                  {gettext("What is a connection to MyJohnDeere operation center?")}
                </h5>
                {gettext(
                  "If you possess a John Deere tractor which is equiped with a wireless connection to the MyJohnDeere operation center, you can authorize Cloudfarm to exchange data with these tractors. Please talk to your dealer for more information about this system."
                )}
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                    &nbsp;
                    <strong>
                      {gettext(
                        "Please note: the serial number is used to identify your vehicle at the online service. Please don't change it."
                      )}
                    </strong>
                  </li>
                  <li>
                    {gettext(
                      'You can can send the base data for your farm to each vehicle, using the buttons in the "Tractors" tab in this dialog. The base data includes field boundaries and way lines.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can create plannings for your work in the "Recording" menu. If you select a connected vehicle under "Machines", the relevant field boundary and way lines will be automatically transmitted to your vehicle.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'If you complete a task for a planning you created beforehand, this planning will automatically be marked "performed", and enriched with data from the task. Alternatively, if no planning was made, a concept recording will be created so you can conveniently convert this into a full recording.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      ' If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkJohnDeere;
